import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpGetOutboundDataSyncPlanner = createApi(`GMPOutboundSyncSlice`,"GET");

const GMPOutboundSyncSlice = createSlice({
  name: 'GMPOutboundSyncSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpGetOutboundDataSyncPlanner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpGetOutboundDataSyncPlanner.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpGetOutboundDataSyncPlanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPOutboundSyncSlice.reducer;